import { Component, OnInit } from '@angular/core';

import { ThemeService } from '@app/shared/services/theme.service';
import { SharedService } from '@app/shared/services/shared.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  currentTheme: string;
  logoPath: string = 'assets/images/logo.png';
  darkLogoPath: string = 'assets/images/dark-logo.png';
  socialLinks: {
    title: string;
    url: string;
    icon: string;
  }[];

  constructor(
    public themeService: ThemeService,
    private sharedService: SharedService,
  ) { }

  ngOnInit(): void {
    this.themeService.themes.subscribe(theme => {
      this.currentTheme = theme;
    });
    this.socialLinks = this.sharedService.socialLinks;
  }

  handleClick() {
    const elem = document.activeElement as HTMLElement | null;
    if (elem) {
      elem.blur();
    }
  }

  toggleTheme() {
    this.themeService.toggleTheme();
  }
}
